<!-- 登录 -->
<template>
  <div
    :class="[
      'loginCont',
      $store.state.currentServerInfo.isSCM ? 'SCM' : 'SPACE'
    ]"
  >
    <!-- 供应链 -->
    <template v-if="$store.state.currentServerInfo.isSCM">
      <div class="Idea">
        <p>从工业时代到信息时代，经历一个多世纪</p>
        <p class="tips">从传统软硬件到物联系统只需<span>一句代码</span></p>
        <img src="../../../../static/images/geeku_iot.png" alt="" />
      </div>
      <div class="Login">
        <div class="title">
          <h1>
            <img class="logo" :src="logo_url" alt="" />
            <span>{{ $store.state.currentServerInfo.title }}</span>
          </h1>
        </div>
        <div class="w-300" v-if="!isForget">
          <el-form ref="form" :model="form">
            <el-form-item>
              <el-input placeholder="请输入账号" v-model="form.user_account">
                <i slot="prefix" class="ico ico-my"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                placeholder="请输入密码"
                type="password"
                @keyup.enter.native="login('form')"
                v-model="form.password"
              >
                <i slot="prefix" class="ico ico-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="flexItem">
                <el-checkbox v-model="checked">记住账号</el-checkbox>
                <span
                  class="forget"
                  @click="
                    isForget = true;
                    forgetForm.user_account = form.user_account;
                  "
                  >忘记密码</span
                >
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                class="login-button"
                type="primary"
                @click="login('form')"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <!-- 忘记密码 -->
        <div class="w-300" v-else>
          <el-form ref="form" :model="forgetForm">
            <el-form-item>
              <el-input
                placeholder="请输入账号"
                v-model="forgetForm.user_account"
              >
                <i slot="prefix" class="ico ico-my"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入邮箱" v-model="forgetForm.email">
                <i slot="prefix" class="ico ico-mail"></i>
              </el-input>
            </el-form-item>
            <el-form-item class="mt50">
              <el-button
                class="login-button"
                type="primary"
                @click="forgetPassword()"
                >确认</el-button
              >
            </el-form-item>
            <el-form-item class="forgetItem clearfix">
              <span class="forget" @click="isForget = false">返回登录</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>

    <!-- 空间 -->
    <template v-else>
      <div class="Login">
        <div class="loginIcon"><img :src="logo_url" alt="" /></div>
        <div class="title">
          <h1>{{ $store.state.currentServerInfo.title }}</h1>
        </div>
        <div class="w-300" v-if="!isForget">
          <el-form ref="form" :model="form">
            <el-form-item>
              <el-input placeholder="账号" v-model="form.user_account">
                <!-- <i slot="prefix" class="ico ico-my"></i> -->
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                placeholder="密码"
                type="password"
                @keyup.enter.native="login('form')"
                v-model="form.password"
              >
                <!-- <i slot="prefix" class="ico ico-lock"></i> -->
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="flexItem">
                <el-checkbox v-model="checked">记住账号</el-checkbox>
                <span
                  class="forget"
                  @click="
                    isForget = true;
                    forgetForm.user_account = form.user_account;
                  "
                  >忘记密码</span
                >
              </div>
            </el-form-item>
            <el-form-item class="mt60">
              <el-button
                class="login-button"
                type="primary"
                @click="login('form')"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <!-- 忘记密码 -->
        <div class="w-300" v-else>
          <el-form ref="form" :model="forgetForm">
            <el-form-item>
              <el-input placeholder="账号" v-model="forgetForm.user_account">
                <!-- <i slot="prefix" class="ico ico-my"></i> -->
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="邮箱" v-model="forgetForm.email">
                <!-- <i slot="prefix" class="ico ico-mail"></i> -->
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="flexItem">
                <div></div>
                <span class="forget" @click="isForget = false">返回登录</span>
              </div>
            </el-form-item>
            <el-form-item class="mt60">
              <el-button
                class="login-button"
                type="primary"
                @click="forgetPassword()"
                >确认</el-button
              >
            </el-form-item>
            <!-- <el-form-item class="forgetItem clearfix">
            <span class="forget" @click="isForget = false">返回登陆</span>
          </el-form-item> -->
          </el-form>
        </div>
      </div>
    </template>

    <!--对话框-->
    <el-dialog :visible.sync="isSuccess">
      <div class="successBox">
        <p class="text">密码已发送到邮箱里，请查收</p>
        <!-- 确认清空忘记密码并隐藏输入框 -->
        <el-button
          type="primary"
          @click="
            isForget = false;
            isSuccess = false;
            forgetForm.user_account = { user_account: '', email: '' };
          "
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  localUserInfo,
  showToast,
  showLoading,
  hideLoading,
  setLogoTitle
} from "../../../../static/js/utility/utility.js";
import { loginApi } from "../../../../static/js/api.js";
let vm;

export default {
  name: "CLogin",
  data() {
    return {
      logo_url: "",

      form: {
        user_account: "",
        password: ""
      },

      forgetForm: {
        user_account: "",
        email: ""
      },

      // 是否忘记密码
      isForget: false,
      // 密码是否发送成功
      isSuccess: false,

      checked: false
    };
  },

  created: function() {
    vm = this;
    console.log("tag", this.$route);
    // console.log('this.$route.query.eUserInfo', decodeURIComponent(this.$route.query.eUserInfo))
    // console.log('vm.$store.state.currentServerInfo', vm.$store.state.currentServerInfo)
    // 判断是否是自动跳转传参
    if (this.$route.query.eUserInfo) {
      // console.log("this", this.$store.state.eUserInfo);
      let eUserInfo = JSON.parse(
        decodeURIComponent(this.$route.query.eUserInfo)
      );
      // localUserInfo.setItem(eUserInfo)
      // this.$store.state.eUserInfo = eUserInfo
      // setLogoTitle()
      this.loginSuccess(eUserInfo);
    }
  },

  mounted() {
    if (this.$route.params.company_ic) {
      this.getCompanyInfo();
    } else {
      this.setLogo();
    }
  },

  methods: {
    // 根据公司代号获取公司信息
    async getCompanyInfo() {
      let data = {
        company_ic: vm.$route.params.company_ic
      };

      let res = await loginApi.getCompanyInfo(data);
      if (res.meta.code == 200) {
        // console.log('res.data.company_name', res.data.company_name)
        setLogoTitle(res.data.logo_url, res.data.company_name);
        vm.setLogo(res.data.logo_url);
      } else {
        // console.log('获取失败', '')
        setLogoTitle();
        vm.setLogo();
        showToast(res.meta.message);
      }
    },

    // 设置logo
    setLogo(logo_url) {
      vm.logo_url = logo_url
        ? logo_url
        : "../../../.." + vm.$store.state.currentServerInfo.logoUrl;
    },

    // 用户登录
    async login() {
      // console.log('输入内容：',vm.form)
      let data = vm.form;
      if (vm.$route.params.company_ic) {
        data.company_ic = vm.$route.params.company_ic;
      }
      showLoading("正在登录...");
      let res = await loginApi.userLogin(data);
      // console.log('res: ',res)
      hideLoading();
      if (res.meta.code === 200) {
        showToast("登录成功");
        //判断是否有勾选记住账号
        // if (vm.checked == true) {
        //   //传入账号名，密码，和保存天数3个参数
        //   vm.setCookie(vm.form.user_account, vm.form.password, 7);
        // }else {
        //   //清空Cookie
        //   vm.clearCookie();
        // }
        // localStorage存储用户token和用户名
        // localUserInfo.setItem(res.data)
        // this.$store.state.eUserInfo = localUserInfo.getItem()
        // setLogoTitle()
        // 登录成功，进入后台 (show_page1为仪表盘或数据控制中心，2为默认首页)
        let eUserInfo = res.data;
        setTimeout(() => {
          vm.loginSuccess(eUserInfo);
        }, 1000);
      } else {
        showToast(res.meta.message);
      }
    },

    // 登录成功跳转页面
    loginSuccess: function(eUserInfo) {
      localUserInfo.setItem(eUserInfo);
      this.$store.state.eUserInfo = eUserInfo;
      setLogoTitle();

      let path = "";
      let show_page = eUserInfo.show_page;
      let isLS = eUserInfo.company_name.includes("绿瘦");
      if (show_page == "1") {
        // path = '/CMap'
        path = isLS ? "DkbLS" : "/Dkb";
      } else {
        path = "/CIndex";
      }
      this.$router.push({
        path: path
      });
    },

    // 忘记密码
    forgetPassword: async function() {
      // console.log('修改信息', this.forgetForm)
      let forgetForm = this.forgetForm;
      if (forgetForm.user_account === "") {
        showToast("请输入账号");
        return;
      }
      if (forgetForm.email === "") {
        showToast("请输入邮箱");
        return;
      }
      showLoading("重置密码中...");
      let res = await loginApi.forgetPassword(forgetForm);
      hideLoading();
      if (res.meta.code === 200) {
        this.isSuccess = true;
      } else {
        showToast(res.meta.message);
      }
    }
  },

  watch: {
    "$route.params.company_ic": function(newVal) {
      // console.log('newVal', newVal)
      if (newVal == "" || newVal == undefined) {
        setLogoTitle();
        this.setLogo();
      } else {
        this.getCompanyInfo();
      }
    }
  }
};
</script>

<style lang="scss">
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-text-fill-color: #666 !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
}
input {
  background-color: transparent;
}
// 供应链
.loginCont.SCM {
  width: 100%;
  height: 100vh;
  background: url("../../../../static/images/loginBg.jpg") center center
    no-repeat;
  background-size: 100% 100%;
  position: relative;
  .Idea {
    position: absolute;
    right: 55.2%;
    top: 21.2%;
    width: 340px;
    font-size: 18px;
    color: #fff;
    line-height: 26px;
    .tips {
      font-size: 30px;
      line-height: 32px;
      font-weight: bold;
      margin: 8px 0 30px;
      span {
        color: #2d83f4;
        margin-left: 30px;
      }
    }
  }
  .Login {
    width: 350px;
    height: 360px;
    position: absolute;
    right: 27.3%;
    top: 12.6%;
    background: #fff;
    border-radius: 10px;
    .mt50 {
      margin-top: 50px;
      margin-bottom: 0px;
    }
    .el-input--prefix .el-input__inner {
      padding-left: 58px;
    }
    .el-input__prefix {
      left: 10px;
    }
    .ico {
      font-size: 25px;
      color: #333;
    }
  }
  h1 {
    font-size: 26px;
    color: #2d83f4;
    margin: 35px 0;
    text-align: center;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    .logo {
      width: 30px;
      margin-right: 5px;
    }
  }
  .chooseTitle {
    text-align: center;
    color: aqua;
    font-size: 2em;
    margin: 50px;
  }
  .w-300 {
    width: 300px;
    margin-left: auto;
    margin-right: auto;
  }
  .login-button {
    width: 300px;
  }
  .notice {
    text-align: center;
  }

  .forgetItem {
    margin-bottom: 0;
  }

  .forgetForm .el-input {
    margin-bottom: 22px;
  }

  .forget,
  .back {
    float: right;
    color: #409eff;
  }
  .back {
    display: block;
    width: 100%;
    font-size: 14px;
    line-height: 40px;
    text-align: right;
    margin-top: 22px;
  }
  .successBox {
    text-align: center;
    .text {
      margin-bottom: 22px;
    }
  }
}

// 空间
.loginCont.SPACE {
  width: 100%;
  height: 100vh;
  background: url("../../../../static/images/loginBg.png") center center
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .Idea {
    position: absolute;
    right: 55.2%;
    top: 21.2%;
    width: 340px;
    font-size: 18px;
    color: #fff;
    line-height: 26px;
    .tips {
      font-size: 30px;
      line-height: 32px;
      font-weight: bold;
      margin: 8px 0 30px;
      span {
        color: #2d83f4;
        margin-left: 30px;
      }
    }
  }
  .Login {
    width: 460px;
    margin-top: -5%;
    .loginIcon {
      width: 160px;
      height: 160px;
      border-radius: 50%;
      background: #fff;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 30px;
      img {
        width: 100%;
      }
    }
    .mt60 {
      margin-top: 60px;
      margin-bottom: 0px;
    }

    .el-input__inner {
      border: none;
      border-bottom: 2px solid #ccc;
      font-size: 24px;
      border-radius: 0;
      color: #666;
    }
    .ico {
      font-size: 25px;
      color: #333;
    }
  }
  h1 {
    font-size: 48px;
    color: #fff;
    margin: 60px 0 40px;
    text-align: center;
    font-weight: normal;
  }
  .chooseTitle {
    text-align: center;
    color: aqua;
    font-size: 2em;
    margin: 50px;
  }
  .w-300 {
    width: 460px;
    border-radius: 10px;
    background-color: #fff;
    padding: 40px 30px;
    // width: 300px;
    // margin-left:auto;
    // margin-right:auto;
  }
  .login-button {
    width: 100%;
    height: 58px;
    font-size: 24px;
    border-radius: 10px;
  }
  .notice {
    text-align: center;
  }

  .forgetItem {
    margin-bottom: 0;
  }

  .forgetForm .el-input {
    margin-bottom: 22px;
  }
  .flexItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    .el-checkbox__inner {
      width: 18px;
      height: 18px;
      &::after {
        border: 2px solid #fff;
        border-left: 0;
        border-top: 0;
        height: 9px;
        left: 5px;
        width: 4px;
      }
    }
    .el-checkbox__label {
      font-size: 18px;
    }
  }
  .forget,
  .back {
    font-size: 18px;
    color: #409eff;
    text-decoration: underline;
  }
  // .back {
  //   display: block;
  //   width: 100%;
  //   font-size: 14px;
  //   line-height: 40px;
  //   text-align: right;
  //   margin-top: 22px;
  // }
  .successBox {
    text-align: center;
    .text {
      margin-bottom: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CLogin/CLogin.vue